<div class="mb-3 border-0">
    <div class="card d-flex flex-row border rounded-2 shadow-sm overflow-hidden" style="min-height: 100px">
      
      <div 
        class="d-flex align-items-center justify-content-center flex-shrink-0"
        ngClass="bg-primary"
        style="width: 60px;">
        <it-icon [name]="'file'" [color]="'white'"></it-icon>
      </div>
  
      <div class="flex-grow-1 d-flex flex-column justify-content-between p-3">
        <div>
          <div class="fw-semibold">{{ note.type.name }}</div>
          <div *ngIf="note.title" class="text-muted small mb-2">{{ note.title }}</div>
          <div class="mb-2">{{ note.text }}</div>
        </div>
  
        <div class="text-muted small">
          Inserito da: <span class="fw-semibold">{{ note.insertUser.name }} {{ note.insertUser.surname }}</span> | 
          Il: <span class="fw-semibold">{{ note.insertDate | date: 'dd/MM/yyyy HH:mm' }}</span>
        </div>

        <div *ngIf="note.read && note.readUser" class="text-muted small">
          Letta da: <span class="fw-semibold">{{ note.readUser.name }} {{ note.readUser.surname }}</span> | 
          Il: <span class="fw-semibold">{{ note.readDate | date: 'dd/MM/yyyy HH:mm' }}</span>
        </div>
      </div>
  
    </div>
  </div>
  